import React from "react";

export default function Footer() {
  return (
    <footer className="w-full bg-[#0A1A2A] text-center py-6 mt-10">
      <p className="text-gray-200 font-semibold text-lg">
        Canal de Comunicación:{" "}
        <a
          href="mailto:atention-user@teanimo.tech"
          className="text-blue-300 hover:text-blue-400"
        >
          atention-user@teanimo.tech
        </a>
      </p>

      <p className="text-gray-300 mt-1 text-sm">
        Para cualquier consulta sobre la plataforma o sobre los resultados, contáctese con un experto.
      </p>
    </footer>
  );
}
